const isMentionRecord = record => record?.sourceCollection === 'mentions';

const recordKey = record => `${record?.sourceCollection || 'unknown'}:${record?.id || ''}`;

const isVoided = record => record?.voided === true ||
  record?.status === 'voided' ||
  record?.originalData?.voided === true ||
  record?.originalData?.status === 'voided';

const detailChildren = (record, direction) => {
  if (direction === 'source') {
    return record?.originalData?.triggeredByDetails || record?.triggeredByDetails || [];
  }
  return record?.originalData?.triggeredDetails || record?.triggeredDetails || [];
};

const relationIds = (record, direction) => {
  if (direction === 'source') {
    return record?.triggeredBy || record?.originalData?.triggeredBy || [];
  }
  return record?.triggered || record?.originalData?.triggeredConsequences || [];
};

/**
 * Return the opposite-kind records linked to a discipline record.
 *
 * Consequences walk backwards through their causal chain until Mentions are
 * reached. Mentions walk forwards through the consequences they produced.
 * Timeline hydration is used when available; the loaded event set fills gaps.
 */
export function getLinkedCorrectionRecords(record, loadedEvents = []) {
  if (!record?.id) return [];

  const direction = isMentionRecord(record) ? 'result' : 'source';
  const wantedMention = !isMentionRecord(record);
  const byId = new Map(loadedEvents.filter(Boolean).map(event => [event.id, event]));
  const found = new Map();
  const visited = new Set([recordKey(record)]);

  const visit = candidate => {
    if (!candidate?.id) return;
    const hydrated = byId.get(candidate.id) || candidate;
    const key = recordKey(hydrated);
    if (visited.has(key)) return;
    visited.add(key);

    if (isMentionRecord(hydrated) === wantedMention && !isVoided(hydrated)) {
      found.set(key, hydrated);
      return;
    }

    const children = detailChildren(hydrated, direction);
    children.forEach(visit);
    relationIds(hydrated, direction).forEach(id => visit(byId.get(id)));
  };

  detailChildren(record, direction).forEach(visit);
  relationIds(record, direction).forEach(id => visit(byId.get(id)));

  return [...found.values()];
}

export function disciplineRecordKind(record) {
  return isMentionRecord(record) ? 'mention' : 'consequence';
}
